export const CONFIGURABLE_SECTION_TYPES = {
  text: "Text",
  product: "Product",
  file: "File",
};
